import { useState } from 'react';

import { useQueryClient } from 'react-query';

import { useMutationSetReportFavoriteStatus } from 'api/mutations/setReportFavoriteStatus.mutation';

export const useSetReportFavoriteStatus = (id: number) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { mutateAsync: setReportFavoriteStatus } = useMutationSetReportFavoriteStatus();
    const queryClient = useQueryClient();
    const updateFavorites = async (status: boolean) => {
        setIsLoading(true);
        await setReportFavoriteStatus(
            {
                reportId: id,
                status,
            },
            {
                onSuccess: async () => {
                    await queryClient.invalidateQueries({
                        queryKey: ['getReport', { id }],
                    });
                    setIsLoading(false);
                    await queryClient.invalidateQueries('getReportList');
                },
            },
        );
    };

    return {
        updateFavorites,
        isUpdateFavoritesLoading: isLoading,
    };
};
